export default __webpack_public_path__ + "static/media/Tectus.18080e43.jpg";